module.exports = __webpack_public_path__ + "img/Group 453.72117529.png";